/**
 * ------------
 * EspacePresse
 * ------------
 * gère la page espace presse
 */
export default class EspacePresse {

    /** Position du scroll dans la page */
    static scrollPosition;

    /** Hauteur de la navigation */
    static navigationHeight = $( '[data-espacepresse-navigation]' ).outerHeight();

    /** Position de la navigation dans la page */
    static navigationScrollPosition;

    constructor() {
        EspacePresse.init();
        EspacePresse.navigation();
        EspacePresse.popup();
        EspacePresse.communiquePresse();
    }

    /**
     * ------------
     * init
     * ------------
     * @description
     * initialise la page
     */
    static init () {
        const marginTop = EspacePresse.navigationHeight + 70;
        $( '[data-espacepresse-contenu]' ).css({'margin-top': '-' + marginTop + 'px'});
    }

    /**
     * --------------
     * navigation
     * --------------
     * gère les évenements liés à la navigation interne de la page
     */
    static navigation () {
        let sections = [];
        $('[data-espacepresse-section]').each(function(index, item) {
            const itemPosition = $( item ).offset().top;
            sections.push({
                item: $( item ).attr('data-espacepresse-section'),
                posX: itemPosition
            });
        });

        // change la couleur de l'élement actif
        $( window ).on('scroll', function() {
            EspacePresse.scrollPosition = $(this).scrollTop();

            $.each( sections, function( index, item ) {
                if( EspacePresse.scrollPosition > item.posX - 100  ) {
                    $( '[data-espacepresse-navigation-id]' ).removeClass('active');
                    $( '[data-espacepresse-navigation-id="' + item.item + '"]' ).addClass('active');
                } else {
                    $( '[data-espacepresse-navigation-id="' + item.item + '"]' ).removeClass('active');
                }
            });

        });

        // animation scroll au clic
        $( document ).on('click', '[data-espacepresse-navigation-id]', function(event) {
            event.preventDefault();
            const id = $(this).attr('data-espacepresse-navigation-id');
            const scrollAnimation = $( '[data-espacepresse-section="' + id + '"]' ).offset().top - 99;
            $("html, body").animate({ scrollTop: scrollAnimation }, 600);
        })
    }

    /**
     * ----------------
     * communiquePresse
     * ----------------
     * @description
     * gère l'animation au survol des communiqués de presse
     */
    static communiquePresse () {
        const items = $('.communique');

        $(items).on('mouseenter', function () {
            $(items).addClass('opacity');
            $(this).removeClass('opacity');
        });

        $(items).on('mouseleave', function () {
            $(items).removeClass('opacity');
        });
    }

    static popup () {
        $( document ).on('click', '.watch', function() {
            const img = $( this ).parent().prev('img').attr('src');

            $( '[data-espacepresse-popup-image]' ).attr('src', img);
            $( '[data-espacepresse-popup]' ).addClass('active');
        });

        $( document ).on('click', '[data-espacepresse-popup]', function() {
           $( this ).removeClass('active');
        });
    }
}